import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApi from "../../utils/httpClient";

const name = "timelines";
const initialState = {
  timelines: [],
  loading: false,
  error: null,
};

export const fetchTimelines = createAsyncThunk(
  "industries/fetchTimelines",
  async () => {
    const data = await axiosApi.get(
      `${process.env.REACT_APP_BASE_URL}industry`
    );
    return data.data;
  }
);

const timelinesSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchTimelines.pending, (state) => {
      state.timelines = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchTimelines.fulfilled, (state, action) => {
      state.timelines = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchTimelines.rejected, (state, action) => {
      state.timelines = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default timelinesSlice.reducer;
